import { error, success } from "@redux-requests/core";
import { StatusCode } from "@utils/optionsSets/OptionSets";
import { fetchArraysAndMerge } from "features/insights/reducer/helpers";
import { EMPTY_GUID, getCxAttribute } from "utils/helpers";
import { InformationType } from "utils/optionsSets/OptionSets";

const initialState = {
	all_Opportunities: [],
	loading: false,
};

const OpportunityReducer = (state = initialState, action) => {
	const responseData = action?.response?.data;
	const requestParams = action?.meta?.requestAction?.params;
	const requestData = action?.meta?.requestAction?.request?.data;
	switch (action.type) {
		case "OPPORTUNITY_GET_ALL":
			return {
				...state,
				loading: state.all_Opportunities.length === 0,
			};
		case success("OPPORTUNITY_GET_ALL"): {
			const { url } = action?.meta?.requestAction?.request;
			if (url.includes("redirectReducer")) return state;

			return {
				...state,
				all_Opportunities: action.response.data,
				loading: false,
			};
		}
		case error("OPPORTUNITY_GET_ALL"):
			return {
				...state,
				loading: false,
			};
		case success("GET_OPPORTUNITY"): {
			const data = responseData;
			const all_Opportunities = state.all_Opportunities?.map((opp) => {
				if (opp.id === requestParams?.opportunityId) {
					opp = { ...opp, ...data };
				}
				return opp;
			});

			return {
				...state,
				all_Opportunities: all_Opportunities,
			};
		}
		case success("CREATE_OPPORTUNITY"):
			return {
				...state,
				all_Opportunities: [...state.all_Opportunities, action.response.data],
			};
		case success("COPY_OPPORTUNITY"):
			return {
				...state,
				all_Opportunities: [...state.all_Opportunities, action?.response?.data],
			};
		case success("UPDATE_OPPORTUNITY"): {
			const modifiedOpportunity = action?.response?.data;

			return {
				...state,
				all_Opportunities: state.all_Opportunities.map((opp) => {
					if (opp.id === modifiedOpportunity.id) {
						opp = modifiedOpportunity;
					}
					return opp;
				}),
			};
		}
		case success("UPDATE_MULTI_OPPORTUNITY"): {
			const modifiedOpportunities = action.meta.requestAction.request.data.modifiedOpportunities;
			const ids = action.meta.requestAction.request.data.modifiedOpportunities?.map((x) => x.id);
			const modifiedAttribNames = action.meta.requestAction.request.data.modifiedAttribNames;

			return {
				...state,
				all_Opportunities: state.all_Opportunities.map((opp) => {
					if (ids.includes(opp.id)) {
						return {
							...opp,
							[modifiedAttribNames]: modifiedOpportunities?.find((x) => x.id === opp?.id)?.[modifiedAttribNames],
						};
					}
					return opp;
				}),
			};
		}
		case success("ARCHIVE_OPPORTUNITY"):
			return {
				...state,
				all_Opportunities: state?.all_Opportunities?.map((opp) => {
					if (opp.id === action.meta.requestAction.request.data.id) {
						return { ...opp, statusCode: StatusCode.Archived };
					}
					return opp;
				}),
			};
		case success("ARCHIVE_MANY_OPPORTUNITIES"):
			return {
				...state,
				all_Opportunities: state?.all_Opportunities?.map((opp) => {
					if (action.response.data.includes(opp.id)) {
						return { ...opp, statusCode: StatusCode.Archived };
					}
					return opp;
				}),
			};
		case success("DELETE_OPPORTUNITY"):
			return {
				...state,
				all_Opportunities: state?.all_Opportunities?.map((opp) => {
					if (opp.id === action.meta.requestAction.request.data.id) {
						return { ...opp, statusCode: StatusCode.Trashed };
					}
					return opp;
				}),
			};
		case success("DELETE_MANY_OPPORTUNITIES"):
			return {
				...state,
				all_Opportunities: state?.all_Opportunities?.map((opp) => {
					if (action.response.data.includes(opp.id)) {
						return { ...opp, statusCode: StatusCode.Trashed };
					}
					return opp;
				}),
			};
		case success("DELETE_OPPORTUNITY_PERMANENT"):
			return {
				...state,
				all_Opportunities: state.all_Opportunities.filter((opp) => opp.id !== action.meta.requestAction.request.data.id),
			};
		case success("DELETE_MANY_OPPORTUNITIES_PERMANENT"):
			return {
				...state,
				all_Opportunities: state.all_Opportunities.filter((opp) => !action.response.data.includes(opp.id)),
			};
		case success("RESTORE_OPPORTUNITY"):
			return {
				...state,
				all_Opportunities: state.all_Opportunities.map((opp) => {
					if (opp.id === action.meta.requestAction.request.data.id) {
						return { ...opp, statusCode: StatusCode.Active };
					}
					return opp;
				}),
			};
		case success("RESTORE_MANY_OPPORTUNITIES"):
			return {
				...state,
				all_Opportunities: state.all_Opportunities.map((opp) => {
					if (action.response.data.includes(opp.id)) {
						return { ...opp, statusCode: StatusCode.Active };
					}
					return opp;
				}),
			};
		case "LINK_TAGS": {
			const { tagIds, recordType, recordIds } = action?.request?.data;
			if (recordType !== "cem_cxattribute") return state;

			return {
				...state,
				all_Opportunities: state.all_Opportunities?.map((opp) => {
					const currentTagAttribute = getCxAttribute({ data: opp, informationType: InformationType.Tags });

					if (currentTagAttribute && recordIds.includes(currentTagAttribute.id)) {
						const updatedTagAttribute = {
							...currentTagAttribute,
							tags: [...currentTagAttribute.tags, ...tagIds],
						};

						return {
							...opp,
							attributes: opp.attributes.map((att) => {
								if (att.type === InformationType.Tags) att = updatedTagAttribute;
								return att;
							}),
						};
					}

					return opp;
				}),
			};
		}
		case "UNLINK_TAGS": {
			const { tagIds, recordType, recordIds } = action?.request?.data;
			if (recordType !== "cem_cxattribute") return state;

			return {
				...state,
				all_Opportunities: state.all_Opportunities?.map((opp) => {
					const currentTagAttribute = getCxAttribute({ data: opp, informationType: InformationType.Tags });

					if (currentTagAttribute && recordIds.includes(currentTagAttribute.id)) {
						const updatedTagAttribute = {
							...currentTagAttribute,
							tags: currentTagAttribute.tags?.filter((tagId) => !tagIds?.includes(tagId)),
						};

						return {
							...opp,
							attributes: opp.attributes.map((att) => {
								if (att.type === InformationType.Tags) att = updatedTagAttribute;
								return att;
							}),
						};
					}

					return opp;
				}),
			};
		}
		case "LINK_GROUPS": {
			const { groupIds, recordType, recordIds } = action?.request?.data;
			if (recordType !== "cem_cxattribute") return state;

			return {
				...state,
				all_Opportunities: state.all_Opportunities?.map((opp) => {
					const currentGroupAttribute = getCxAttribute({ data: opp, informationType: InformationType.Group });

					if (currentGroupAttribute && recordIds.includes(currentGroupAttribute.id)) {
						const updatedGroupAttribute = {
							...currentGroupAttribute,
							groups: [...currentGroupAttribute.groups, ...groupIds],
						};

						return {
							...opp,
							attributes: opp.attributes.map((att) => {
								if (att.type === InformationType.Group) att = updatedGroupAttribute;
								return att;
							}),
						};
					}

					return opp;
				}),
			};
		}
		case "UNLINK_GROUPS": {
			const { groupIds, recordType, recordIds } = action?.request?.data;
			if (recordType !== "cem_cxattribute") return state;

			return {
				...state,
				all_Opportunities: state.all_Opportunities?.map((opp) => {
					const currentGroupAttribute = getCxAttribute({ data: opp, informationType: InformationType.Group });

					if (currentGroupAttribute && recordIds.includes(currentGroupAttribute.id)) {
						const updatedGroupAttribute = {
							...currentGroupAttribute,
							groups: currentGroupAttribute.groups?.filter((groupId) => !groupIds?.includes(groupId)),
						};

						return {
							...opp,
							attributes: opp.attributes.map((att) => {
								if (att.type === InformationType.Group) att = updatedGroupAttribute;
								return att;
							}),
						};
					}

					return opp;
				}),
			};
		}
		case success("UPDATE_CX_ATTRIBUTE"): {
			const { modifiedCxAttribute } = action.meta.requestAction.request.data;
			if (modifiedCxAttribute.opportunityId === EMPTY_GUID) return state;
			return {
				...state,
				all_Opportunities: state.all_Opportunities?.map((opp) => {
					if (opp.id === modifiedCxAttribute.opportunityId) {
						opp.attributes = opp.attributes?.map((attr) => {
							if (attr.id === modifiedCxAttribute.id) {
								attr = responseData;
							}
							return attr;
						});
					}
					return opp;
				}),
			};
		}
		case "UPDATE_CX_ATTRIBUTES": {
			const { modifiedCxAttributes } = action?.request?.data;
			const oppIds = modifiedCxAttributes.map((att) => att?.opportunityId);
			return {
				...state,
				all_Opportunities: state.all_Opportunities?.map((opp) => {
					if (oppIds?.includes(opp?.id)) {
						const modifiedCxAttribute = modifiedCxAttributes.find((att) => att.opportunityId === opp?.id);
						opp.attributes = opp.attributes.map((attr) => {
							if (attr.id === modifiedCxAttribute.id) attr = modifiedCxAttribute;
							return attr;
						});
					}
					return opp;
				}),
			};
		}
		case success("UPDATE_USER_MODIFICATION"): {
			const { objId, objName } = requestData || {};

			if (objName !== "cem_cxopportunity") return state;
			const { userName } = requestParams;
			return {
				...state,
				all_Opportunities: state.all_Opportunities?.map((opp) => {
					if (opp.id === objId) {
						opp.modifiedBy = userName;
						opp.lastUpdated = new Date().toISOString();
					}
					return opp;
				}),
			};
		}
		case success("GET_CJM_OPPORTUNITIES"): {
			return {
				...state,
				all_Opportunities: fetchArraysAndMerge(state.all_Opportunities, responseData),
			};
		}
		case "BULK_UNLINK_OPPORTUNITY_RECORDS": {
			const { ids, recIds } = action?.request?.data;

			return {
				...state,
				all_Opportunities: state.all_Opportunities?.map((opp) => {
					if (ids?.includes(opp?.id)) {
						opp.linkedPersonas = opp.linkedPersonas?.filter((id) => !recIds?.includes(id));
					}

					return opp;
				}),
			};
		}
		default:
			return state;
	}
};
export default OpportunityReducer;
